import {processLink} from '../../../classes/lib-common'

const TextualAdvice = (name, advice, report) =>{
	const title = name+"\n\n"
		const adviceFixedInVersions = ()=>{
			return advice.fixedInVersions && advice.fixedInVersions.length?("The issue is fixed in version: "+advice.fixedInVersions.join(", ")):""
		}
		const description = ()=>{
			return `Description:\n`+
			`${advice.description}\n\n${adviceFixedInVersions()}\n\n`;
		}
		
		const info = ()=>{
			let content= `More Information:\n`;
			for(const link of advice.links){
				content+=` - ${processLink(link.url,link.type)}\n`
			}
			return content+"\n\n"	
		}
		const hierarchy = ()=>{
			if(!report.hierarchy || !report.hierarchy.length) return "";
			let content="Hierarchy:\n";
			for(let i=0; i<report.hierarchy.length; i++){
				const level=report.hierarchy[i];
				for(let j=0; j<i;j++){
					content+=" "
				}
				if(i>0)content+="└";
				content+=level+"\n";
			}
			return content+"\n\n"
		}
		const locations = ()=>{
			if(!report.locations || !report.locations.length) return "";
			let content= "Locations:\n";
			for(const location of report.locations){
				content+=` - ${location}\n`
			}
			return content+"\n\n";
		}

		const safeVersions = ()=>{
			if(!report.safeVersions || (!report.safeVersions.latestPatch && !report.safeVersions.latestMinor && !report.safeVersions.latestMajor)) return "";
			let versions = 0;
			for(const version in report.safeVersions){
				if(report.safeVersions[version]) versions++;
			}
			let content = `Suggestion:\n${versions>1?"Please upgrade to any of these versions:":"Please upgrade to this version:"}\n`;
			if(report.safeVersions.latestPatch) content+=`Patch release: ${report.safeVersions.latestPatch}\n`;
			if(report.safeVersions.latestMinor) content+=`Minor release: ${report.safeVersions.latestMinor}\n`;
			if(report.safeVersions.latestMajor) content+=`Major release: ${report.safeVersions.latestMajor}\n`;

			return content+"\n"
		}
		return `${title}${description()}${info()}${hierarchy()}${locations()}${safeVersions()}`
}

export default TextualAdvice